import * as React from 'react';

import styled from 'styled-components';

import { BREAKPOINT } from '../../packages/constants';

export interface GridRowProps {
    children: React.ReactNode;
    bgColor?: string;
}

const GridRow = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-color: ${(props: GridRowProps): string => (props.bgColor ? props.bgColor : 'transparent')};
    width: 100%;

    @media (min-width: ${BREAKPOINT.TABLET}) {
        flex-direction: row;
    }
`;

export default GridRow;
